import "vuetify/styles";
import { createVuetify } from "vuetify";

const color = "#102a63";

export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          primary: color,
        },
      },
      dark: {
        colors: {
          primary: color,
        },
      },
    },
  },
});
